export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          随时随地 畅享观影
        </h2>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-lg p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 border border-background-200/60">
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-600"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3">
                蘑菇影视移动端适配
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                支持手机浏览器直接访问，无需下载安装任何应用。自适应屏幕尺寸，数据流量下也能流畅播放。无论在地铁、午休还是旅途中，打开浏览器即可随时观看最新电影和热门电视剧。
              </p>
              <div className="flex flex-wrap items-center gap-3 justify-center md:justify-start">
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  <i className="ri-check-line"></i> iOS 适配
                </span>
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  <i className="ri-check-line"></i> Android 适配
                </span>
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  <i className="ri-check-line"></i> 免下载安装
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}